import React from 'react'
import ProductTable from './ProductTable'

const Products = () => {
  return (
    <div>
      <ProductTable/>
    </div>
  )
}

export default Products